import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './core/http.service';
import { ResponseData } from './model/response.model';
import { URLService } from './_url.service';
@Injectable({
  providedIn: 'root'
})

export class OrderService {

  constructor(private httpService: HttpService, private URLService: URLService) { }

  IsThisServiceAvailableForUser(serviceId?: number,userId?: number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.IsThisServiceAvailableForUser, { serviceId: serviceId,userId: userId });
  }
  GetCreateRequestDetails(userId?: number): Observable<ResponseData> {
    if (userId === null)
      return this.httpService.get(this.URLService.GetCreateRequestDetailsUrl);
    else
      return this.httpService.get(this.URLService.GetCreateRequestDetailsUrl, { userId: userId });
  }

  CreateCustomerRequest(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.CreateCustomerRequestUrl, model);
  }

  UpdateCustomerRequest(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.UpdateCustomerRequest, model);
  }

    ApproveRDCRequest(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ApproveRDCRequest, model);
  }
  //  UpdateCustomerRequest(model: any,attachmentPath:string): Observable<ResponseData> {
  //   return this.httpService.post(this.URLService.UpdateCustomerRequest, {model,attachmentPath:attachmentPath});
  // }

  GetOrderDetails(orderId: number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetOrderDetailsUrl, { orderId: orderId });
  }

  GetOrdersList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetOrdersListUrl, filterModel);
  }

  GetOrdersServicesList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetOrdersServicesListUrl, filterModel);
  }

  ApplyRequestAction(applyActionModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ApplyRequestActionUrl, applyActionModel);
  }

  ApplyRequestOrderDetailAction(applyActionModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ApplyRequestOrderDetailActionUrl, applyActionModel);
  }

  GetOrderServiceDetails(requestOrderDetailId: number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetOrderServiceDetailsUrl, { requestOrderDetailId: requestOrderDetailId });
  }

  GetPendingAssignOrdersServicesList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetPendingAssignOrdersServicesListUrl, filterModel);
  }

  GetAssignedOrdersServicesList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetAssignedOrdersServicesListUrl, filterModel);
  }

  AssignRequestOrderDetailList(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.AssignRequestOrderDetailListUrl, model);
  }
  AssignRdcOrder(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.AssignRdcOrderUrl, model);
  }


  ApplyForAssignRequestOrderDetail(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ApplyForAssignRequestOrderDetailUrl, model);
  }

  GetPendingAssignApproveOrdersServicesList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetPendingAssignApproveOrdersServicesListUrl, filterModel);
  }

  GetCreateResultFormDetails(requestOrderDetailId: number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetCreateResultFormDetailsUrl, { requestOrderDetailId: requestOrderDetailId });
  }

  GetUserOrdersServiceList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetUserOrdersServiceListUrl, filterModel);
  }

  GetCorporateUserOrdersServiceList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetCorporateUserOrdersServiceListUrl, filterModel);
  }

  SendOtpSMS(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.SendOtpSMSUrl, model);
  }

  ExecuteResultForm(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ExecuteResultFormUrl, model);
  }
  ExecuteAssetRDCResultForm(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ExecuteAssetRDCResultFormUrl, model);
  }

  GetPendingAuditAssignOrdersServicesList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetPendingAuditAssignOrdersServicesListUrl, filterModel);
  }

  GetAssignedAuditOrdersServicesList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetAssignedAuditOrdersServicesListUrl, filterModel);
  }

  AssignAuditRequestOrderDetailList(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.AssignAuditRequestOrderDetailListUrl, model);
  }

  GetFilterDetails(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetFilterDetailsUrl);
  }

  UpdateOrderAttachment(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.UpdateOrderAttachmentUrl, model);
  }
  UpdateOrderAttachmentRDC(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.UpdateOrderAttachmentRDCUrl, model);
  }

  GetWebsiteStatistics(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetWebsiteStatisticsUrl);
  }

  GetPendingPaymentCorporateUserOrdersServiceList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetPendingPaymentCorporateUserOrdersServiceListUrl, filterModel);
  }

  DownloadAttachment(requestOrderDetailId: number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.DownloadAttachmentUrl, { requestOrderDetailId: requestOrderDetailId });
  }

    getPricePerPage(filePath: string,serviceId:number, implementationId:number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetPricePerPageUrl, {filePath:filePath,serviceId:serviceId,implementationId:implementationId});
  }

}
